/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AttachmentResponseDto } from '../models/AttachmentResponseDto';
import type { DownloadUrlResponseDto } from '../models/DownloadUrlResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AttachmentControllerService {

    /**
     * @param parentId
     * @param parentType
     * @param type
     * @param formData
     * @returns AttachmentResponseDto OK
     * @throws ApiError
     */
    public static upload(
        parentId: number,
        parentType: string,
        type: string,
        formData?: {
            files: Array<Blob>;
        },
    ): CancelablePromise<Array<AttachmentResponseDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/attachments/upload',
            query: {
                'parentId': parentId,
                'parentType': parentType,
                'type': type,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param type
     * @param formData
     * @returns AttachmentResponseDto OK
     * @throws ApiError
     */
    public static uploadDraft(
        type: string,
        formData?: {
            files: Array<Blob>;
        },
    ): CancelablePromise<Array<AttachmentResponseDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/attachments/upload-draft',
            query: {
                'type': type,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param parentId
     * @param parentType
     * @returns AttachmentResponseDto OK
     * @throws ApiError
     */
    public static list(
        parentId: number,
        parentType: string,
    ): CancelablePromise<Array<AttachmentResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/attachments/list',
            query: {
                'parentId': parentId,
                'parentType': parentType,
            },
        });
    }

    /**
     * @param attachmentUuid
     * @param expiry
     * @returns DownloadUrlResponseDto OK
     * @throws ApiError
     */
    public static downloadUrl(
        attachmentUuid: string,
        expiry: number = 300,
    ): CancelablePromise<DownloadUrlResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/attachments/download-url',
            query: {
                'attachmentUuid': attachmentUuid,
                'expiry': expiry,
            },
        });
    }

    /**
     * @param attachmentUuid
     * @returns any OK
     * @throws ApiError
     */
    public static delete1(
        attachmentUuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/attachments/delete',
            query: {
                'attachmentUuid': attachmentUuid,
            },
        });
    }

}
